export const pages = {
	'boltHome': { id: 'boltHome', page: 'home', getter: () => import(/* webpackChunkName: 'home' */ 'components/bolt/home/home') },
	'hubspotForm': { id: 'hubspotForm', page: 'hubspotForm', getter: () => import(/* webpackChunkName: 'hubspotForm' */ 'components/bolt/hubspotForm/hubspotForm') }
};
export const sections = [
	{ id: 'boltSynopsis', getter: () => import(/* webpackChunkName: "synopsis" */ 'components/bolt/synopsis/synopsis'), component: 'synopsis', parent: 'boltHome' },
	{ id: 'hubspotForm', getter: () => import(/* webpackChunkName: "hubspotForm" */ 'components/bolt/hubspotForm/hubspotForm'), component: 'hubspotForm', parent: 'boltHome' },
	{ id: 'boltFeaturedVideos', getter: () => import(/* webpackChunkName: "featuredVideos" */ 'components/bolt/featuredVideos/featuredVideos'), component: 'featuredVideos', parent: 'boltHome' }
];
